import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=7347e0b5&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports